

export const P01_03 = {
  "columns": 5,
  "rows": 1,
  "visual": {
    "id": 4,
    "type": "treemap",
    "colorTheme": "colorTheme1",
    "title": "Share by District",
    "xAxis": "",
    "yAxis": "",
    "binding": {
      "data": {
        "title": 'DistrictName',
        "value": 'Share',
        "tooltip": 'ActualSales',
        "currency": true,
        "percent": true,
        "endpoint": "P01.3",
        "filter": {
          "show": false,
          "local": ["DistrictGroupCode"],
        },
        "parameters": [
          { "key": "FromMonth", "value": "2024" },
          { "key": "FromYear", "value": "1" },
          { "key": "ToMonth", "value": "2024" },
          { "key": "ToYear", "value": "1" },
          { "key": "ConfigTypeCode", "value": "" },
          { "key": "DistributorCode", "value": '' }
        ]
      },
      "context": {
        "point": {
          "onClick": {  }
        }
      }
    }
  }
}
